import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.programCodes;
export const programCodesSelector = (state: RootState) => getState(state).data;
export const programCodesIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const programCodesIsReadySelector = (state: RootState) => getState(state).isReady;
export const programCodesErrorSelector = (state: RootState) => getState(state).error;
